import {
  HouseholdAccount,
  HouseholdAccountTypePagination,
} from "@fartherfinance/frontend/api/Households/types";

export const getAccountProviderDisplayName = (
  account: HouseholdAccount
): string => {
  if (account.accountProvider === "FartherManagedAccount") {
    return "Farther Managed";
  }

  if (account.accountProvider === "ManuallyTrackedAccount") {
    return "External Manually Tracked";
  }

  switch (account.type) {
    case "credit":
      return "External Credit Card";
    case "depository":
      return "External Banking";
    case "investment":
      return "Investment Account";
    case "loan":
      return "External Loans";
    case "Savings":
      return "External Savings Account";
    case "Checking":
      return "External Checking Account";
    default:
      return "External Account";
  }
};

export const getHouseholdAccountType = (
  account: HouseholdAccount
): HouseholdAccountTypePagination => {
  if (account.accountProvider === "FartherManagedAccount") {
    return "FartherManagedAccount";
  }

  if (account.accountProvider === "ManuallyTrackedAccount") {
    return "ManuallyTrackedAccount";
  }

  return account.type;
};
